export default "__VITE_ASSET__dd2d45be__"